import React from 'react';
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../../common/components/form/form.module';

export const AccountTaxDetailsComponent = ({ onInnerFormChange, selectedAccounts, gstType, gstRegistrationType }: any) => (
  <>
    <AccordionContainer
      child={
        <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
          <InputContainer
            label="GST Number"
            name="GSTNumber"
            onValueChange={(event: any) => {
              onInnerFormChange(
                event.target.value,
                'GSTInfo.GSTNumber',
                selectedAccounts?.GSTInfo
              )
            }}
            type="text"
            value={selectedAccounts?.GSTInfo?.GSTNumber}
          />
          <InputContainer

            label="PAN Number"
            name="PANNumber"
            onValueChange={(event: any) => {
              onInnerFormChange(
                event.target.value,
                'GSTInfo.PANNumber',
                selectedAccounts?.GSTInfo
              )
            }}
            type="text"
            value={selectedAccounts?.GSTInfo?.PANNumber}
          />
          <InputContainer
            label="GST Type"
            labelField="Text"
            list={gstType}
            onValueChange={(event: any, newValue: any) => {
              onInnerFormChange(
                event.target.value,
                'GSTInfo.GSTTypeId',
                selectedAccounts?.GSTInfo
              )
            }}
            optionName='Choose GST Type'
            type="select"
            value={selectedAccounts?.GSTInfo?.GSTTypeId}
            valueField="Value"
          />
          <InputContainer
            label="GST Registration Type"
            labelField="Text"
            list={gstRegistrationType}
            onValueChange={(event: any, newValue: any) => {
              onInnerFormChange(
                event.target.value,
                'GSTInfo.GSTRegistrationTypeId',
                selectedAccounts?.GSTInfo
              )
            }}
            optionName='Choose GSTRegistrationType'
            type="select"
            value={selectedAccounts?.GSTInfo?.GSTRegistrationTypeId}
            valueField="Value"
          />
        </div>
      }
      expandedPanel="Tax Information"
      headerTitle="GST Info"
    />
  </>
 )

 export default AccountTaxDetailsComponent;